export const reasonTypes = [
  { name: "Service Query", code: "SERVICE_QUERY" },
  {
    name: "New / Additional Service Request",
    code: "ADDITIONAL_SERVICE_REQUEST",
  },
  { name: "Contract / Fees query", code: "FEES_QUERY" },
  { name: "Tech Support (IT/Helpdesk)", code: "TECH_SUPPORT" },
  { name: "Implementation", code: "IMPLEMENTATION" },
];
